<form name="vm.form" #mainForm="ngForm" (ngSubmit)="vm.handleFormSubmit(mainForm)" class="c-form u-wrapper" data-testid="symptom-previsit-submit" [attr.data-initialized]="!!vm.isInitialized" [attr.data-results-visible]="!vm.hideResults" [attr.data-condition-count]="vm.interview?.diagnosis?.conditions?.length || 0" *ngIf="!vm.showOnlyThankYouSection" [ngStyle]="!vm.isInitialized && {'min-height': '200px'}"
	autocomplete="off" novalidate>
	<div class="c-card u-osb-md" *ngIf="!vm.hideTriageResults && vm.interview?.triage">
		<div class="c-content c-content--lg c-content--s{{vm.level}}">
			<div class="o-grid o-grid--center-v">
				<div class="o-grid__cell o-grid__cell--w-fixed u-no-pr u-no-p@up-to-md">
					<i class="o-icon o-icon--{{vm.icon}} c-text c-text--xl c-text--s4" aria-hidden="true"></i>
				</div>
				<div class="o-grid__cell">
					<h1 class="c-text c-text--heading c-text--s4 c-text--lg">{{vm.title}}</h1>
				</div>
			</div>
		</div>
		<div class="c-content c-content--lg">
			<div class="o-grid o-grid--column">
				<div class="o-grid__cell u-no-p@up-to-md u-osb-sm">
					<p class="c-text c-text--spaced">{{vm.description}}</p>
				</div>
			</div>
		</div>
	</div>
	<div class="c-card u-osb-md">
		<div class="o-grid" *ngIf="vm.isInitialized">
			<div class="o-grid__cell o-grid__cell--w-100 u-no-p@up-to-md">
				<div class="c-content c-content--lg">
					<h2 class="c-text c-text--heading c-text--lg">{{'Symptom_Check.Results.Show_Communication_Preference' | translate}}</h2>

					<label for="wantSickLeave" class="c-form__label u-osb-xs ">{{'Symptom_Check.Results.Sick_Leave_Section' | translate}}</label>
					<div class="u-osb-lg" id="wantSickLeave" *ngFor="let additionalRequestOption of vm.additionalRequestOptions">
						<label class="c-checkbox">
							<input type="checkbox" name="additionalRequestOption.fieldName" [(ngModel)]="vm.selectedServiceIds[additionalRequestOption.id]">
							<span id="additionalRequestOptionLabel">{{ additionalRequestOption.label }}</span>
						</label>
					</div>

					<div class="c-divider c-divider--h u-osb-lg" *ngIf="vm.isPhotoUploadEnabled"></div>
					
					<label class="c-form__label u-osb-xs" *ngIf="vm.isPhotoUploadEnabled">{{'Symptom_Check.Results.Upload_Pictures' | translate}}</label>
                    <div class="c-form__group u-osb-sm u-osb-md" *ngIf="vm.isPhotoUploadEnabled">
                        <div (click)="vm.triggerFileSelectionDialog()"
                             *ngIf="vm.fileUpload.files?.length < 3"
                             class="c-file_upload u-osb-md">
                            <div class="c-file_upload__item">
                                <img [attr.src]="'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/pin' + vm.iconSuffix + '.svg'">
                            </div>
                            <div class="c-file_upload__item">
                                <div class="c-text c-text--md">
                                    {{ 'Symptom_Check.Results.Select_Picture' | translate }}
                                </div>
                            </div>
                        </div>
                        <input id="fileInput" name="fileInput" 
                               [(ngModel)]="vm.file"
                               type="file"
                               [fileChange]="vm.uploadFile"
                               accept=".png,.jpg,.jpeg"
                               style="display: none">
                        <div class="u-osb-md">
                            <div *ngFor="let file of vm.fileUpload.files ; let $index=index" class="c-file_item">
                                {{file.originalFileName}}
                                <div class="c-file_item__remove">
                                    <a id="deleteFileButton{{$index}}" href="javascript:void(0)" (click)="vm.deleteFile(file)">
                                        <i class="o-icon o-icon--x u-no-mr" style="color: red"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="c-divider c-divider--h u-osb-lg"></div>

					<label for="locationSelection" class="c-form__label u-osb-xs">{{'Symptom_Check.Results.Title_Communication_Preference' | translate}}</label>
					<div class="c-form__group u-osb-sm" id="locationSelection" [ngClass]="{'c-form__group--error': vm.submitted && !vm.hasLocationSelected }" *ngFor="let location of vm.locationSelection ; let $index=index">
						<label class="c-checkbox" style="">
							<input type="checkbox" name="{{location.fieldName}}" [(ngModel)]="vm.selectedServiceIds[location.id]">
							<span id="locationLabel{{$index}}">{{ location.label }}</span>
						</label>
						<p class="c-text c-text--s3" *ngIf="vm.submitted && !vm.hasLocationSelected && location.requiredErrorMessage">{{ location.requiredErrorMessage }}</p>
						<p *ngIf="location.type === 'TEXT_ERROR' && vm.submitted && !vm.hasLocationSelected" class="c-text c-text--s3" style="">{{ location.label }}</p>
					</div>

					<div class="c-divider c-divider--h u-ost-lg"></div>

					<div class="c-form">
						<label for="patientNoteForDoctor" class="c-form__label u-osb-xs" [innerHtml]="vm.otherDescriptionConf.label"></label>
						<textarea id="patientNoteForDoctor" name="vm.otherDescriptionConf.fieldName" class="c-form__input" [(ngModel)]="vm.otherDescriptionConf.content"></textarea>

						<div class="o-grid__cell u-no-p">
							<div class="o-grid u-ost-lg">
								<div class="o-grid__cell o-grid__cell--w-50 o-grid__cell--w-fixed@md-and-up u-no-p">
									<button id="forwardToDoctorButton" type="submit" class="c-button c-button--s1 c-button--lg c-button--fit">{{'Symptom_Check.Results.Forward_to_Doctor' | translate}}</button>
								</div>
								<div class="o-grid__cell o-grid__cell--w-45 o-grid__cell--w-fixed@md-and-up u-no-p" style="margin-left: 15px;">
									<button id="dontForwardToDoctorButton" type="button" (click)="vm.goBackToMainPage()" class="c-button c-button--s6 c-button--lg c-button--fit">
										{{'Symptom_Check.Results.Dont_Forward' | translate}}</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="c-card">
		<div class="o-grid" *ngIf="!vm.hideResults && vm.isInitialized && vm.interview?.diagnosis?.conditions">
			<div class="o-grid__cell o-grid__cell--w-100 u-no-p@up-to-md">
				<div class="c-content c-content--lg">
					<h2 id="interviewResultsTitle" data-testid="symptom-interview-results" class="c-text c-text--heading c-text--lg">{{'Symptom_Check.Results.Title' | translate}}</h2>
					<p class="c-text" [innerHtml]="vm.generalDescription"></p>
					<div class="c-divider c-divider--h"></div>
					<div class="o-grid o-grid--wrap u-osb-sm" *ngFor="let condition of vm.interview.diagnosis.conditions ; let $index=index">
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-55@md-and-up u-no-p@up-to-md u-no-pl" [ngSwitch]="vm.hasTreatmentGuideline(condition.id)">
							<button id="treatmentGuideButton{{$index}}" type="button" class="c-button c-button--link u-text-left" *ngSwitchCase="true" (click)="vm.openTreatmentGuideline(condition.id)">
								{{condition.common_name}} {{'Symptom_Check.Results.Read_More' | translate}}
							</button>
							<p class="c-text" *ngSwitchDefault>{{condition.common_name}}</p>
						</div>
						<div class="o-grid__cell o-grid__cell--w-80 o-grid__cell--w-85@sm-and-up o-grid__cell--w-35@md-and-up u-no-p@up-to-md" style="cursor: pointer" (click)="vm.openConditionInfo(condition)">
							<item-progress [value]="condition.probability" [max]="1"></item-progress>
						</div>
						<div id="conditionInfoButton{{$index}}" class="o-grid__cell o-grid__cell--w-20 o-grid__cell--w-15@sm-and-up o-grid__cell--w-10@md-and-up u-no-pr" style="cursor: pointer"
							(click)="vm.openConditionInfo(condition)">
							<p class="c-text c-text--right">{{condition.probability * 100 | number: '1.1-1'}}%</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<loader-overlay data-testid="symptom-results-loading" *ngIf="!vm.isInitialized || vm.isProcessing"></loader-overlay>
	<div id="stateCheckElementForAutomatedTests" *ngIf="vm.isInitialized"></div>
</form>

<pre-visit-thank-you *ngIf="vm.showOnlyThankYouSection" [isInitialized]="vm.isInitialized" [isRecordTicketForPerson]="vm.isRecordTicketForPerson"
	[informationSection]="vm.thankYouInformationSection" [preVisitTicketId]="vm.preVisitTicketId">
</pre-visit-thank-you>
